// Currency + Manila date formatting
const phpFmt = new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' });

export function peso(centavos) {
  return phpFmt.format((centavos || 0) / 100);
}

export function manilaDate(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-PH', {
    timeZone: 'Asia/Manila', year: 'numeric', month: 'short', day: 'numeric',
  });
}

export function manilaDateTime(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleString('en-PH', {
    timeZone: 'Asia/Manila', year: 'numeric', month: 'short', day: 'numeric',
    hour: 'numeric', minute: '2-digit',
  });
}

export function daysLeft(iso) {
  if (!iso) return 0;
  return Math.max(0, Math.ceil((new Date(iso).getTime() - Date.now()) / 86400000));
}

export const FUEL_LABELS = {
  full: 'Full', three_quarter: '3/4', half: '1/2', quarter: '1/4', near_empty: 'Near empty',
};

export const METHOD_LABELS = {
  cash: 'Cash', gcash_manual: 'GCash', bank_transfer: 'Bank transfer', card_manual: 'Card',
  gcash: 'GCash',
};

export const PLAN_LABELS = { starter: 'Starter', pro: 'Pro', elite: 'Elite' };
